import * as React from "react";
import { useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Grid } from "@mui/material";

import { CommonButton } from "@/components/common/buttons/CommonButton";
import Title from "@/components/molecules/Title";
import { ChargerExcludeConstants } from "./ChargerExcludeConstants";
import {
  ChargerExcludeModel,
  ChargerExcludeSavedState,
} from "@/models/chargerExclude";
import { getShortDatetime } from "@/util/datetime";
import { getChargerExcludeDetailAPI } from "@/util/api/chargerExclude";
import { useStatefulNavigator } from "@/util/useStatefulNavigator";

export const ChargerExcludeDetail = () => {
  const params = useParams<{ id: string }>();
  const id = params.id;
  const [detail, setDetail] = React.useState<ChargerExcludeModel>();
  const { savedState, navigate } =
    useStatefulNavigator<ChargerExcludeSavedState>();

  const goToEdit = React.useCallback(
    () =>
      navigate(`/charger_exclude/${id}/edit`, {
        page: savedState?.page,
        searchData: savedState?.searchData,
        orderTypes: savedState?.orderTypes,
        officesSelected: savedState?.officesSelected,
      }),
    [
      id,
      navigate,
      savedState?.page,
      savedState?.searchData,
      savedState?.orderTypes,
      savedState?.officesSelected,
    ]
  );

  const goToList = React.useCallback(
    () =>
      navigate(`/charger_exclude`, {
        page: savedState?.page,
        searchData: savedState?.searchData,
        orderTypes: savedState?.orderTypes,
        officesSelected: savedState?.officesSelected,
      }),
    [
      navigate,
      savedState?.page,
      savedState?.searchData,
      savedState?.orderTypes,
      savedState?.officesSelected,
    ]
  );

  // Load chargerExclude detail
  const getChargerExcludeDetail = async (id: number) => {
    try {
      const res = await getChargerExcludeDetailAPI(Number(id));
      const detail = res.data;
      setDetail(detail);
    } catch (err) {
      console.log("==Error when get detail charger exclude==", err);
    }
  };

  // Reload chargerExclude detail when id change
  React.useEffect(() => {
    if (id) {
      getChargerExcludeDetail(Number(id));
    }
  }, [id]);

  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        sx={{ paddingLeft: 2, paddingRight: 2, mt: 3 }}
      >
        <Grid container spacing={2} sx={{ display: "flex", pl: 2 }}>
          <Title style={{ flexGrow: 1 }}>
            {ChargerExcludeConstants.ChargerExcludeDetails}
          </Title>
          <CommonButton
            btnType="Return"
            sx={{
              height: 35,
              mr: 1,
            }}
            onClickBtn={() => goToList()}
          />
          <CommonButton
            btnType="Edit"
            sx={{ height: 35 }}
            onClickBtn={() => goToEdit()}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={10} md={10} lg={14}>
            <Paper sx={{ p: 1, display: "flex", flexDirection: "column" }}>
              <Table size="small" className="gx-info-table">
                <TableBody>
                  <TableRow sx={{ height: 45 }}>
                    <TableCell>
                      {ChargerExcludeConstants.InstallationLoationOfficeName}
                    </TableCell>
                    <TableCell>
                      {detail?.chargers?.offices?.displayName}
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ height: 45 }}>
                    <TableCell>{ChargerExcludeConstants.ChargerName}</TableCell>
                    <TableCell>{detail?.chargers?.name}</TableCell>
                  </TableRow>
                  <TableRow sx={{ height: 45 }}>
                    <TableCell>
                      {ChargerExcludeConstants.SuspensionOfUseStartDate}
                    </TableCell>
                    <TableCell>{getShortDatetime(detail?.startAt)}</TableCell>
                  </TableRow>
                  <TableRow sx={{ height: 45 }}>
                    <TableCell>{ChargerExcludeConstants.Reason}</TableCell>
                    <TableCell>{detail?.cause}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
